import { createSlice } from "@reduxjs/toolkit";
import { BASE_URL } from "../utils/config";

const initialState = {
  brandsList: [],
  brand: null,
};

const brandSlice = createSlice({
  name: "brand",
  initialState,
  reducers: {
    updateBrandsList: (state, action) => {
      state.brandsList = action.payload;
    },
    getBrand: (state, action) => {
      let bData = state.brandsList.filter((brand) => {
        let bId = Number(action.payload);
        return brand.brandId == bId;
      });
      state.brand = bData[0];
    },
  },
});
export const { updateBrandsList, getBrand } = brandSlice.actions;

export const getBrands = () => (dispatch) => {
  fetch(BASE_URL, {
    method: "POST",
    body: JSON.stringify({
      action: "getBrands",
      src: "dashboard",
      brandid: 0,
      categoryid: 0,
      retrievalmode: "",
    }),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
    },
  })
    .then((response) => response.json())
    .then((response) => {
      dispatch(updateBrandsList(response.data));
    })
    .catch((err) => {
      console.log(err.message);
    });
};

export const createBrand = (name, status) => (dispatch) => {
  fetch(BASE_URL, {
    method: "POST",
    body: JSON.stringify({
      action: "createBrand",
      brandname : name,
      status : status,
      src: "dashboard",
      brandid: 0,
      categoryid: 0,
    }),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
    },
  })
    .then((response) => response.json())
    .then((response) => {
      console.log(response)
    })
    .catch((err) => {
      console.log(err.message);
    });
};

export const updateBrand = (name,brandId, status, imagepath) => (dispatch) => {
  fetch(BASE_URL, {
    method: "POST",
    body: JSON.stringify({
      action: "updateBrand",
      brandid: brandId,
      brandname : name,
      status : status,
      src: "dashboard",
      brandid: 0,
      categoryid: 0,
    }),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
    },
  })
    .then((response) => response.json())
    .then((response) => {
      console.log(response)
    })
    .catch((err) => {
      console.log(err.message);
    });
};

export default brandSlice.reducer;
